import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "sonner";

import { CCard, CCardBody } from "@coreui/react";

import { comboApi } from "src/1/apis/combo.api";
import { CTable } from "src/1/common/components/others";
import { history, warningDelete } from "src/App";
import { CCheckbox } from "src/common/components/controls";
import { COMBO_STATUSES_OPTIONS } from "src/configs/constant";
import { findLabel } from "src/utils/funcs";

import { ComboToolbar } from "../../components";

const DanhSachCombo = () => {
  //#region Data
  const [params, setParams] = useState({
    page: 1,
    size: 10,
    status: "",
    code: "",
    name: "",
    start: null,
    end: null,
  });

  const [selectedId, setSelectedId] = useState("");

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["danh-sach-combo", params],
    queryFn: () => comboApi.getPaginate(params),
    select: (response) => response?.data,
  });

  const listData = useMemo(() => data?.data ?? [], [data]);
  //#endregion

  //#region
  const onLimitChange = (newLimit) =>
    setParams((prev) => ({
      ...prev,
      page: 1,
      size: newLimit,
    }));

  const onPageChange = (newPage) =>
    setParams((prev) => ({
      ...prev,
      page: newPage,
    }));

  const onSearch = (data) =>
    setParams((prev) => ({ ...prev, ...data, page: 1 }));

  const onEdit = () => history.push(`/combos/edit/${selectedId}`);

  const onRemove = () => {
    warningDelete({
      onConfirm: () => comboApi.remove(selectedId),
      onSuccess: () => {
        refetch();
        return "Xóa combo thành công";
      },
      onError: (error) => error?.message || "Xóa combo không thành công!",
    });
  };

  const onPause = async () => {
    try {
      await comboApi.stop(selectedId);
      refetch();
      toast.success("Ngưng chạy combo thành công!");
    } catch (error) {
      toast.error(error?.message || "Lỗi");
    }
  };
  //#endregion

  //#region Render
  const headers = [
    {
      key: "selection",
      label: "",
      align: "center",
      width: 30,
      cellRender: (value, record) => (
        <CCheckbox
          disabled={Math.abs(record?.approved_status) === 1}
          value={selectedId === record?.id}
          onChange={() => {
            if (selectedId === record?.id) {
              setSelectedId("");
            } else {
              setSelectedId(record?.id);
            }
          }}
        />
      ),
    },
    {
      key: "code",
      label: "Mã Combo",
      align: "left",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => history.push(`/combos/detail/${record.id}`)}
        >
          {value}
        </span>
      ),
    },
    {
      key: "name",
      label: "Tên Combo",
      align: "left",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => history.push(`/combos/detail/${record.id}`)}
        >
          {value}
        </span>
      ),
    },
    {
      key: "cost",
      label: "Tổng giá trị giá cost",
      align: "right",
      columnType: "number",
    },
    {
      key: "unit",
      label: "Đơn vị tính",
    },
    {
      key: "created_by",
      label: "Người đề xuất",
      align: "left",
    },
    {
      key: "status",
      label: "Trạng thái",
      cellRender: (value) => (
        <span>{findLabel(value, COMBO_STATUSES_OPTIONS)}</span>
      ),
    },
    {
      key: "from",
      label: "Áp dụng từ ngày",
      columnType: "date",
    },
    {
      key: "to",
      label: "Đến ngày",
      columnType: "date",
    },
    {
      key: "note",
      label: "Ghi chú",
      align: "left",
    },
  ];
  return (
    <>
      <ComboToolbar
        params={params}
        canEdit={!!selectedId}
        canRemove={!!selectedId}
        onEdit={onEdit}
        onRemove={onRemove}
        onSearch={onSearch}
        onPause={onPause}
      />

      <CCard>
        <CCardBody className="pt-0 px-0">
          <div className="mt-3">
            <CTable
              loading={isFetching}
              headers={headers}
              data={listData}
              fontSizeBody={16}
              divider
              page={params?.page}
              pages={data?.metadata?.last_page}
              limit={params?.size}
              total={data?.metadata?.total}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
            />
          </div>
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
export default DanhSachCombo;
